import dayjs from 'dayjs';
import { CalendarView } from './SingleDateFilter.types';

export const viewControls = {
  week: {
    next: (date: Date) => dayjs(date).add(1, 'month').toDate(),
    prev: (date: Date) => dayjs(date).subtract(1, 'month').toDate(),
    formatter: (date: Date) => dayjs(date).format('MMMM YYYY'),
  },
  month: {
    next: (date: Date) => dayjs(date).add(1, 'year').toDate(),
    prev: (date: Date) => dayjs(date).subtract(1, 'year').toDate(),
    formatter: (date: Date) => dayjs(date).format('YYYY'),
  },
  year: {
    next: (date: Date) => dayjs(date).add(20, 'year').toDate(),
    prev: (date: Date) => dayjs(date).subtract(20, 'year').toDate(),
    formatter: (date: Date) => {
      const yearFrom = Math.floor(dayjs(date).year() / 20) * 20 + 1;
      const yearTo = yearFrom + 19;
      return `${yearFrom} - ${yearTo}`;
    },
  },
};

export const viewUpdaters: Record<CalendarView, (current: dayjs.Dayjs, selected: Date) => dayjs.Dayjs> = {
  year: (current, selected) => current.year(selected.getFullYear()),
  month: (current, selected) => current.month(selected.getMonth()),
  week: (_, selected) => dayjs(selected),
};

export function isValidDate(value: unknown): value is Date {
  return value instanceof Date && !isNaN(value.getTime());
}

export const getStartOfDay = (inputDate: Date) => {
  const normalizedDate = new Date(inputDate);
  normalizedDate.setHours(0, 0, 0, 0);
  return normalizedDate;
};
